import {
  boolean,
  index,
  pgTable,
  primaryKey,
  text,
  timestamp,
} from "drizzle-orm/pg-core";
import { nanoid } from "nanoid";
import { user } from "./auth";

export const announcements = pgTable(
  "announcements",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    title: text("title").notNull(),
    summary: text("summary"),
    body: text("body").notNull(),
    imageUrl: text("image_url"),
    priority: text("priority")
      .$type<"NORMAL" | "HIGH" | "URGENT">()
      .notNull()
      .default("NORMAL"),
    showOnOpen: boolean("show_on_open").notNull().default(false),
    sendPush: boolean("send_push").notNull().default(false),
    pushSentAt: timestamp("push_sent_at", {
      withTimezone: true,
      mode: "date",
    }),
    publishAt: timestamp("publish_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    expiresAt: timestamp("expires_at", {
      withTimezone: true,
      mode: "date",
    }),
    isActive: boolean("is_active").notNull().default(true),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("announcements_active_publish_idx").on(
      t.isActive,
      t.publishAt,
      t.expiresAt,
    ),
  ],
);

export const announcementReads = pgTable(
  "announcement_reads",
  {
    userId: text("user_id")
      .notNull()
      .references(() => user.id, { onDelete: "cascade" }),
    announcementId: text("announcement_id")
      .notNull()
      .references(() => announcements.id, { onDelete: "cascade" }),
    readAt: timestamp("read_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    primaryKey({ columns: [t.userId, t.announcementId] }),
    index("announcement_reads_announcement_idx").on(t.announcementId),
    index("announcement_reads_user_idx").on(t.userId),
  ],
);
